// import { persistQueryClient } from '@tanstack/query-persist-client-core';
// import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
// import { QueryClient } from '@tanstack/react-query';

// export const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 1000 * 60 * 60 * 24, // 24 часа
//       gcTime: 1000 * 60 * 60 * 24 * 7, // 7 дней
//       refetchOnWindowFocus: false,
//     },
//   },
// });

// const lruCache = new Map<string, string>();

// const localStoragePersistor = createSyncStoragePersister({
//   storage: {
//     getItem: (key) => lruCache.get(key) || null,
//     setItem: (key, value) => {
//       console.log("lruCache.size", lruCache.size)
//       if (lruCache.size >= 10000) {
//         const oldestKey = lruCache.keys().next().value;
//         lruCache.delete(oldestKey ?? "");
//       }
//       lruCache.set(key, value);
//     },
//     removeItem: (key) => lruCache.delete(key),
//   },
// });

// persistQueryClient({
//   queryClient,
//   persister: localStoragePersistor,
// });

// import { persistQueryClient } from '@tanstack/query-persist-client-core'
// import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { MutationCache, QueryClient } from '@tanstack/react-query'
// import { openDB } from 'idb'

// Create an IndexedDB persister
// const indexedDBPersister = createAsyncStoragePersister({
//     storage: {
//         getItem: async (key) => {
//             const db = await openDB('ReactQueryCache', 1, {
//                 upgrade(db) {
//                     db.createObjectStore('cache')
//                 },
//             })
//             return db.get('cache', key)
//         },
//         setItem: async (key, value) => {
//             const db = await openDB('ReactQueryCache', 1, {
//                 upgrade(db) {
//                     db.createObjectStore('cache')
//                 },
//             })
//             await db.put('cache', value, key)
//         },
//         removeItem: async (key) => {
//             const db = await openDB('ReactQueryCache', 1, {
//                 upgrade(db) {
//                     db.createObjectStore('cache')
//                 },
//             })
//             await db.delete('cache', key)
//         },
//     },
// })

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
            gcTime: 1000 * 60 * 60 * 24 * 7, // 7 days
            refetchOnWindowFocus: false,
        },
    },
    // https://tkdodo.eu/blog/automatic-query-invalidation-after-mutations#tie-it-to-the-mutationkey
    mutationCache: new MutationCache({
        onSuccess: (_data, _variables, _context, _mutation) => {
            // if (isQueryMutationKey(mutation.options.mutationKey)) {
            //     void queryClient.invalidateQueries({
            //         queryKey: mutation.options.mutationKey,
            //     })
            // }
        },
    }),
})

// persistQueryClient({
//     queryClient,
//     persister: indexedDBPersister,
//     maxAge: 1000 * 60 * 60 * 24 * 7, // 7 days
//     // maxSize: 10000, // Increase the maximum number of cached queries
// })
